module.exports = "<section class=\"venmoAuth\" id=\"venmoAuth\" content>\n    <div class=\"row-fluid\">\n\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n\n    </div>\n</section>\n\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-venmoAuth/template.html
// module id = ./pages/xo-venmoAuth/template.html
// module chunks = 0